import { CATEGORIES, type CategoryKey, SCORE_LEGEND } from "./constants";

export type ScoreMap = Record<CategoryKey, number | null>;

export function emptyScores(): ScoreMap {
  return CATEGORIES.reduce((acc, c) => {
    acc[c.key] = null;
    return acc;
  }, {} as ScoreMap);
}

/**
 * Weighted final score, rounded to one decimal.
 * Returns null until every category has a numeric value, so the UI does not
 * show a misleading "final" before the editor is done.
 */
export function weightedFinal(scores: ScoreMap): number | null {
  let sum = 0;
  let weightSum = 0;
  for (const c of CATEGORIES) {
    const v = scores[c.key];
    if (v === null || v === undefined || Number.isNaN(v)) return null;
    sum += v * c.weight;
    weightSum += c.weight;
  }
  if (weightSum === 0) return null;
  return Math.round((sum / weightSum) * 10) / 10;
}

export function scoreBand(final: number | null): string {
  if (final === null) return "—";
  const band = SCORE_LEGEND.find((b) => final >= b.min && final <= b.max + 0.0001);
  return band ? band.label : "—";
}

export function clampScore(raw: unknown): number | null {
  const n = typeof raw === "number" ? raw : Number(raw);
  if (!Number.isFinite(n)) return null;
  if (n < 1) return 1;
  if (n > 10) return 10;
  return Math.round(n * 10) / 10;
}
